/* T2S Noir Gold — theme scripts (no dependencies) */
(function () {
  'use strict';

  var theme = window.theme || {};
  var root = (theme.routes && theme.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = drawer.querySelector('.drawer__panel button, .drawer__panel a, .drawer__panel input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }

    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }

    var cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && document.getElementById('CartDrawer')) { e.preventDefault(); openDrawer(document.getElementById('CartDrawer')); return; }

    var searchBtn = e.target.closest('[data-search-open]');
    if (searchBtn) {
      var dlg = document.getElementById('SearchDialog');
      if (dlg && dlg.showModal) { dlg.showModal(); var i = dlg.querySelector('input[type="search"]'); if (i) i.focus(); }
      else { window.location.href = root + 'search'; }
      return;
    }

    // close open nav dropdowns when clicking elsewhere
    $$('.js-nav-details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    $$('.js-nav-details[open]').forEach(function (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); });
  });

  // only one dropdown open at a time
  $$('.js-nav-details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      $$('.js-nav-details[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    });
  });

  // close search dialog on backdrop click
  var searchDialog = document.getElementById('SearchDialog');
  if (searchDialog) {
    searchDialog.addEventListener('click', function (e) { if (e.target === searchDialog) searchDialog.close(); });
  }

  /* ---------- cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function renderSections(ids, url) {
    var target = (url || window.location.pathname) + (url && url.indexOf('?') > -1 ? '&' : '?') + 'sections=' + ids.join(',');
    return fetch(target).then(function (r) { return r.json(); }).then(function (data) {
      ids.forEach(function (id) {
        if (!data[id]) return;
        var fresh = parse(data[id]);
        if (id === 'cart-drawer') {
          var panel = $('#CartDrawer .drawer__panel');
          var newPanel = fresh.querySelector('.drawer__panel');
          if (panel && newPanel) panel.innerHTML = newPanel.innerHTML;
        } else {
          var current = document.getElementById('shopify-section-' + id);
          var next = fresh.getElementById('shopify-section-' + id);
          if (current && next) current.innerHTML = next.innerHTML;
        }
      });
    });
  }

  function refreshCart() {
    var ids = [];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    var main = $('[data-main-cart]');
    if (main) ids.push(main.getAttribute('data-section-id'));
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCount(cart.item_count);
      if (!ids.length) return cart;
      return renderSections(ids, root.replace(/\/$/, '') + '/cart').then(function () { return cart; });
    });
  }

  function changeLine(line, quantity, container) {
    if (container) container.classList.add('is-loading');
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .catch(function () { window.location.reload(); })
      .finally(function () { if (container) container.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var line = btn.closest('[data-line]');
    if (!line) return;
    e.preventDefault();
    changeLine(parseInt(line.getAttribute('data-line'), 10), parseInt(btn.getAttribute('data-qty-change'), 10), line.closest('.cart-items'));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var line = input.closest('[data-line]');
    if (!line) return;
    changeLine(parseInt(line.getAttribute('data-line'), 10), parseInt(input.value || '0', 10), line.closest('.cart-items'));
  });

  /* ---------- product form (add to cart) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || !document.getElementById('CartDrawer')) return; // fall back to normal post → /cart
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-form-error]');
    var label = button ? button.querySelector('span') : null;
    var original = label ? label.textContent : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.disabled = true; }
    if (label && theme.strings) label.textContent = theme.strings.adding;
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) {
        if (errorBox) { errorBox.textContent = res.description || res.message || (theme.strings && theme.strings.cartError); errorBox.hidden = false; }
        return;
      }
      return refreshCart().then(function () { openDrawer(document.getElementById('CartDrawer')); });
    }).catch(function () {
      form.removeAttribute('data-product-form');
      form.submit();
    }).finally(function () {
      if (button) { button.removeAttribute('aria-disabled'); button.disabled = false; }
      if (label) label.textContent = original;
    });
  });

  /* ---------- variant picker ---------- */
  $$('[data-variant-picker]').forEach(function (picker) {
    var dataEl = picker.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var sectionId = picker.getAttribute('data-section-id');
    var productUrl = picker.getAttribute('data-url');
    var section = picker.closest('[data-product-section]') || document;

    picker.addEventListener('change', function () {
      var selected = $$('fieldset', picker).map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });

      var idInputs = $$('form[data-product-form] input[name="id"]', section);
      var buttons = $$('[data-add-button]', section);

      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; var s = b.querySelector('span'); if (s) s.textContent = theme.strings.unavailable; });
        return;
      }
      idInputs.forEach(function (i) { i.value = variant.id; });
      if (window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', u.toString());
      }

      // re-render price, buttons and media from the server so money formats stay exact
      fetch(productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parse(html);
          $$('[data-swap]', section).forEach(function (el) {
            var fresh = doc.querySelector('[data-swap="' + el.getAttribute('data-swap') + '"]');
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
          if (variant.featured_media) showMedia(section, String(variant.featured_media.id));
        });
    });
  });

  /* ---------- purchase options (selling plans) ---------- */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-purchase-options] input[type="radio"]');
    if (!radio) return;
    var box = radio.closest('[data-purchase-options]');
    var hidden = box.querySelector('[data-selling-plan-input]');
    hidden.value = radio.value;
    hidden.disabled = !radio.value;
    var section = box.closest('[data-product-section]') || document;
    var price = section.querySelector('[data-swap="price"] .price__current');
    if (price && radio.getAttribute('data-price')) price.textContent = radio.getAttribute('data-price');
    var compare = section.querySelector('[data-swap="price"] .price__compare');
    if (compare) compare.hidden = !!radio.value;
  });

  /* ---------- product media thumbnails ---------- */
  function showMedia(section, mediaId) {
    var items = $$('[data-media-id]', section);
    if (!items.length) return;
    items.forEach(function (m) { m.hidden = m.getAttribute('data-media-id') !== mediaId; });
    $$('[data-thumb]', section).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') === mediaId ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    showMedia(thumb.closest('[data-product-section]') || document, thumb.getAttribute('data-thumb'));
  });

  /* ---------- lazy video embeds ---------- */
  document.addEventListener('click', function (e) {
    var poster = e.target.closest('[data-video-poster]');
    if (!poster) return;
    var frame = document.createElement('iframe');
    frame.src = poster.getAttribute('data-video-src');
    frame.title = poster.getAttribute('aria-label') || 'Video';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    frame.allowFullscreen = true;
    poster.replaceWith(frame);
  });

  /* ---------- quantity steppers on product page ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, next);
  });
})();
